// =============================================================================
// FILE: packages/shared/src/config/masterKey.config.ts
// PURPOSE: Legacy compatibility shim. Production auth uses database roles.
//
// This config is shared between packages/main (Electron) and
// packages/renderer (React), ensuring the bypass is enforced at every layer
// of the application stack — auth, IPC middleware, license gate, and UI.
// =============================================================================

// ---------------------------------------------------------------------------
// Hard-coded Super-Admin email list intentionally removed.
// ---------------------------------------------------------------------------
export const MASTER_ADMIN_EMAILS: ReadonlyArray<string> = [] as const;

// ---------------------------------------------------------------------------
// Tier granted to all master admins
// ---------------------------------------------------------------------------
export const MASTER_LICENSE_TIER = 'designer' as const;

// ---------------------------------------------------------------------------
// isMasterAdmin — case-insensitive lookup
// ---------------------------------------------------------------------------
/**
 * Returns true if the supplied email belongs to a Global Super-Admin.
 * Safe to call with null / undefined — returns false.
 */
export function isMasterAdmin(email: string | null | undefined): boolean {
  void email;
  return false;
}
